module.exports = __webpack_public_path__ + "img/scene5copy03.3ba1b21e.png";